import React, { useState, useEffect } from 'react';
import Button from 'components/generics/Button';
import InputLabel from 'components/generics/InputLabel';


const EditTypeOrganismForm = props => {
    const [ typeOrganism, setTypeOrganism ] = useState(props.currentTypeOrganism)
  
    useEffect(
      () => {
        setTypeOrganism(props.currentTypeOrganism)
      },
      [ props ]
    )
    // You can tell React to skip applying an effect if certain values haven’t changed between re-renders. [ props ]
  
    const handleInputChange = (name, value) => {
      setTypeOrganism({ ...typeOrganism, [name]: value })
    }
  
    return (
      <form className="form-client"
        onSubmit={event => {
          event.preventDefault()
          props.handleUpdateTypeOrganism(typeOrganism.id, typeOrganism)
        }}
      >

      <InputLabel
				name="name"
				type="text"
				value={typeOrganism.name}
				defaultStyle='secondary'
				label="Type d'organisme"
				onChange={(e) => { handleInputChange('name', e); }}/>

        <div className="div-button">
          <Button
            type="submit"
            defaultStyle="btn btn-primary"
            text="Enregistrer"
            textColor="primary"
          />
          <Button 
            type="button"
            text="Annuler"  
            onClick={() => props.setEditing(false)} 
            defaultStyle="btn btn-secondary"
          />
        </div>
      </form>
    )
  }

export default EditTypeOrganismForm;
